module.exports = {
    trackMyOrderProgress: {
        dispatched: 'Dispatched',
        placed: 'Placed',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/track-my-order-progress.js